import React from "react"
import { Card, CardBody, Row , Col} from "reactstrap"

const Miniwidget = props => {
  return (
    <React.Fragment>
      <Row>
        <Col xl={4} sm={6}>
          <Card className={"mini-stat "+ props.reports[0].color}>
            <CardBody className="card-body mini-stat-img">
              <div className="mini-stat-icon">
                <i className={"float-end mdi mdi-" + props.reports[0].iconClass}></i>
              </div>
              <div className="text-white">
                <h6 className="mb-3 font-size-16 text-white">{props.reports[0].title}</h6>
                <h2 className="text-white font-size-17">{props.reports[0].total}</h2>
                <span className="ms-2">{props.reports[0].message}</span>
              </div>
            </CardBody>
          </Card>
        </Col>
        <Col xl={4} sm={6}>
          <Card className={"mini-stat "+ props.reports[1].color}>
            <CardBody className="card-body mini-stat-img">
              <div className="mini-stat-icon">
                <i className={"float-end mdi mdi-" + props.reports[1].iconClass}></i>
              </div>
              <div className="text-white">
                <h6 className="mb-3 font-size-16 text-white">{props.reports[1].title}</h6>
                <h2 className="text-white font-size-17">{props.reports[1].total}</h2>
                <span className="ms-2">{props.reports[1].message}</span>
              </div>
            </CardBody>
          </Card>
        </Col>
        <Col xl={4} sm={6}>
          <Card className={"mini-stat "+ props.reports[2].color}>
            <CardBody className="card-body mini-stat-img">
              <div className="mini-stat-icon">
                <i className={"float-end mdi mdi-" + props.reports[2].iconClass}></i>
              </div>
              <div className="text-white">
                <h6 className="mb-3 font-size-16 text-white">{props.reports[2].title}</h6>
                <h2 className="text-white font-size-17">{props.reports[2].total}</h2>
                <span className="ms-2">{props.reports[2].message}</span>
              </div>
            </CardBody>
          </Card>
        </Col>
        <Col xl={4} sm={6}>
          <Card className={"mini-stat "+ props.reports[3].color}>
            <CardBody className="card-body mini-stat-img">
              <div className="mini-stat-icon">
                <i className={"float-end mdi mdi-" + props.reports[3].iconClass}></i>
              </div>
              <div className="text-white">
                <h6 className="mb-3 font-size-16 text-white">{props.reports[3].title}</h6>
                <h2 className="text-white font-size-17">{props.reports[3].total}</h2>
                <span className="ms-2">{props.reports[3].message}</span>
              </div>
            </CardBody>
          </Card>
        </Col>
        <Col xl={4} sm={6}>
          <Card className={"mini-stat "+ props.reports[4].color}>
            <CardBody className="card-body mini-stat-img">
              <div className="mini-stat-icon">
                <i className={"float-end mdi mdi-" + props.reports[4].iconClass}></i>
              </div>
              <div className="text-white">
                <h6 className="mb-3 font-size-16 text-white">{props.reports[4].title}</h6>
                <h2 className="text-white font-size-17">{props.reports[4].total}</h2>
                <span className="ms-2">{props.reports[4].message}</span>
              </div>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </React.Fragment> 
  )

}

export default Miniwidget
